import React from "react";
import { Link } from "react-router-dom";
import { Heart, ShoppingBag, Trash2, Pill } from "lucide-react";
import { toast } from "sonner";
import { imgUrl, eur } from "../lib/api";
import { useWishlist } from "../context/WishlistContext";
import { useCart } from "../context/CartContext";

export default function Wishlist() {
  const { items, remove } = useWishlist();
  const { addItem } = useCart();

  if (items.length === 0) return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center">
      <Heart className="h-14 w-14 text-[#1E3A2F]/30 mx-auto mb-5" />
      <h1 className="font-serif-display text-3xl text-[#1E3A2F]">Η λίστα αγαπημένων είναι άδεια</h1>
      <p className="text-[#536D61] mt-2">Αποθηκεύστε προϊόντα που σας ενδιαφέρουν.</p>
      <Link to="/shop" className="mt-6 inline-block bg-[#1E3A2F] text-white px-7 py-3.5 rounded-sm hover:bg-[#111C18]">Δείτε τα προϊόντα</Link>
    </div>
  );

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12">
      <h1 className="font-serif-display text-4xl text-[#1E3A2F] mb-8">Αγαπημένα</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {items.map((p) => (
          <div key={p.id} className="flex gap-4 bg-white border border-[#E5E9E4] rounded-sm p-4" data-testid={`wishlist-item-${p.id}`}>
            <Link to={`/product/${p.id}`} className="h-24 w-24 shrink-0 rounded-sm overflow-hidden bg-[#E8F0E1] flex items-center justify-center">
              {p.images?.[0] ? <img src={imgUrl(p.images[0])} alt={p.name} className="h-full w-full object-cover" /> : <Pill className="h-8 w-8 text-[#1E3A2F]/40" />}
            </Link>
            <div className="flex-1 min-w-0">
              <Link to={`/product/${p.id}`} className="font-medium text-[#1E3A2F] hover:underline line-clamp-2">{p.name}</Link>
              <p className="text-[#1E3A2F] font-semibold mt-1">{eur(p.price)}</p>
              <div className="mt-3 flex items-center gap-2">
                <button onClick={() => { addItem(p, 1); toast.success("Προστέθηκε στο καλάθι"); }} disabled={p.stock <= 0} className="inline-flex items-center gap-1.5 bg-[#1E3A2F] text-white text-sm px-3 py-2 rounded-sm hover:bg-[#111C18] disabled:opacity-40">
                  <ShoppingBag className="h-4 w-4" /> Στο καλάθι
                </button>
                <button onClick={() => remove(p.id)} className="text-[#C25953] hover:text-[#a3433d] p-2" data-testid={`wishlist-remove-${p.id}`}><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
